import React, { useState } from 'react';
import { appPath, APP_PATHS } from '../../../utils/appPaths.js';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '../../../AbstractElements';
import IncomeStepOne from './IncomeStepOne';
import IncomeStepTwo from './IncomeStepTwo';
import { Container, Row, Button } from 'reactstrap';

function NewIncome() {
    const [activeStep, setActiveStep] = useState(0);
    const [incomeId, setIncomeId] = useState(null);
    const navigate = useNavigate();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <>
            <Breadcrumbs
                parent="Income"
                title="Incomes"
                mainTitle="Create Income"
                buttons={[
                    <Button
                        size="sm"
                        color="primary"
                        onClick={() => navigate(appPath('/income/income-list'))}
                    >
                        <i className="fa fa-arrow-left me-1"></i> Back to Incomes
                    </Button>,
                ]}
            />
            <Container fluid={true} style={{ paddingTop: '10px' }}>
                <Row>
                    {activeStep === 0 && (
                        <IncomeStepOne handleNext={handleNext} setIncomeId={setIncomeId} />
                    )}
                    {activeStep === 1 && (
                        <IncomeStepTwo handleBack={handleBack} handleNext={handleNext} incomeId={incomeId} />
                    )}
                </Row>
            </Container>
        </>
    );
}

export default NewIncome;

